import React, {useState} from "react";
import {useSearchParams} from 'react-router-dom';

const Pagination = ({data}) => {
    const [searchParams, setSearchParams] = useSearchParams();

    //set initial page and limit
    const initialLimit = Number(searchParams.get("limit")) || 25;

    const [limit, setLimit] = useState(initialLimit);
    const pages = [];

    for (let i = 1; i <= data.totalPages; i++) {
        pages.push(i);
    }

    //Call the api after page change & on limit change
    const updateURLAndFetch = (newPage, newLimit) => {
        setSearchParams({page: newPage, limit: newLimit});
    };

    //On page change handler
    const onPageChange = (newPage) => {
        updateURLAndFetch(newPage, limit)
    }

    //on limit change handler
    const onLimitChange = (e) => {
        const newLimit = Number(e.target.value); // Get the new limit
        setLimit(newLimit);
        updateURLAndFetch(1, newLimit)
    }

    //to show start and end items on current page or total items
    const start = (data.currentPage - 1) * limit + 1;
    const end = Math.min(data.currentPage * limit, data.results);

    return (
        <div className="d-flex justify-content-between align-items-center flex-wrap mt-7 pagination">
            {/* Page Limit Select */}
            {data.results !== 0 && <div className="form-group mb-0">
                <label className="me-2">Show</label>
                <select
                    className="form-select d-inline-block w-auto"
                    value={limit}
                    onChange={onLimitChange}
                >
                    {[10, 25, 50, 100].map((val) => (
                        <option key={val} value={val}>{val}</option>
                    ))}
                </select>
                <span className="ms-2">per page</span>
            </div>}
            <span className="me-4 ms-auto">{start}-{end} of {data.results}</span>

            {/* Page Buttons */}
            {data.totalPages > 1 && <nav aria-label="Page navigation">
                <ul className="pagination pagination-sm justify-content-center mb-0 flex-wrap">
                    <li className={`page-item ${data.currentPage === 1 ? 'disabled' : ''}`}>
                        <button className="page-link"
                                onClick={() => onPageChange(data.currentPage - 1)}
                        >
                            Previous
                        </button>
                    </li>

                    {pages.map((page) => (
                        <li key={page} className={`page-item ${page === data.currentPage ? 'active' : ''}`}>
                            <button className="page-link"
                                    onClick={() => onPageChange(page)}
                            >
                                {page}
                            </button>
                        </li>
                    ))}

                    <li className={`page-item ${data.currentPage === data.totalPages ? 'disabled' : ''}`}>
                        <button className="page-link"
                                onClick={() => onPageChange(data.currentPage + 1)}
                        >Next
                        </button>
                    </li>
                </ul>
            </nav>}

        </div>
    )
}

export default Pagination;
